import React from "react";
import { NavLink } from "react-router-dom";
import { BuyBilet } from "../common/ButtonBuyBilet";

export const Headers = () => {
  let IsAuthTrue = () => {
    return (
      <div className="infoForAuthUsers">
        <span className="info_user">
          <img src="/img/avatar.png" alt="" />
          <span className="nameAndPrice">
            <p className="Name_LName">Ivan Fomin</p>
            <p className="balance">1000 BTC</p>
          </span>
          <span className="b_list_info">
            <svg
              width="9"
              height="5"
              viewBox="0 0 9 5"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1.29688 1L4.79687 4L8.29687 1" stroke="#212129" />
            </svg>
          </span>
        </span>
        <span className="b_out">
          {" "}
          {/* Кнопка */}
          <svg
            width="12"
            height="16"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.46596 0V1.16624H0.758789V14.8167L4.46596 14.8197V16L11.2347 14.7842L11.2417 1.22422L4.46596 0ZM5.58862 7.46439C5.81595 7.46439 6.00025 7.70421 6.00025 8C6.00025 8.29586 5.81598 8.53561 5.58862 8.53561C5.36127 8.53561 5.177 8.29586 5.177 8C5.17697 7.70421 5.3613 7.46439 5.58862 7.46439ZM1.85947 13.7169V2.26692H4.46596V13.719L1.85947 13.7169Z"
              fill="#F6C465"
            />
          </svg>
        </span>
      </div>
    );
  };

  let IsAuthFalse = () => {
    return (
      <div className="infoForAuthUsers">
        <span onClick={() => alert("Reg")} className="b_logining">
          <p>Вход</p>
        </span>
        <span className="b_registration">
          {" "}
          {/* Кнопка */}
          <p>Регистрация</p>
        </span>
      </div>
    );
  };

  let isAuth = false; // Авториизован/Не авторизован

  return (
    <header>
      <div className="top-sections-header">
        <div className="container-header">
          <NavLink to="/">
            <div className="logo">
              <h3>lotto</h3>
              <h4>36</h4>
            </div>
          </NavLink>
          <div className="button-from-rigth">
            <BuyBilet img="/img/ticket_1.png" />
            {isAuth === true ? <IsAuthTrue /> : <IsAuthFalse />}
            <span className="list_languige" onClick={() => <div>En</div>}>
              <span>RU</span>
              <svg
                width="9"
                height="6"
                viewBox="0 0 9 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.29688 1.36923L4.79687 4.41539L8.29687 1.36923"
                  stroke="#A3A7D1"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
      <div className="nav_meny">
        <div className="container-header">
          <NavLink to="/regulations">
            <p>Правила</p>
          </NavLink>
          <NavLink to="/commission">
            <p>Комиссия</p>
          </NavLink>
          <NavLink to="/DistributionCoins">
            <p>Распределение монет</p>
          </NavLink>
          <NavLink to="/LotteryHistory">
            <p>История лотерей</p>
          </NavLink>
          <NavLink to="/CheckHash">
            <p>Проверить Hash</p>
          </NavLink>
        </div>
      </div>
    </header>
  );
};
